import { Persistent } from './persistent.model';
import { TipoAttributoEntity } from './tipoattributoentity.model';

export class AttributoEntity extends Persistent   {

  constructor(public id: number,
              public nome: string,
              public tipo: TipoAttributoEntity,
              public entitaNome: string,
              public multiplo: boolean,
              public descr: string) {
    super(id);
  }

  public getLabel() {
    return this.nome;
  }

}
